import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/instance";
import { endpoints } from "../../constants/endpoints";
import { toast } from "react-toastify";

export const ProfessionalAddTimingsAPI = createAsyncThunk(
    "ProfessionalAddTimingsAPI",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(endpoints.professionalAddTimingShedule(), data)
            return response
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const UpdateProfessionalTimeAPI = createAsyncThunk(
    "UpdateProfessionalTimeAPI",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(endpoints.updateProfessionalEditTimeSlot(), data)
            return response
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const ProfessionalShowTimingsAPI = createAsyncThunk(
    "ProfessionalShowTimingsAPI",
    async (data, { rejectWithValue }) => {
        try {
            const id = data?.id;
            const response = await api.get(endpoints.professionalShowTimingShedule(id));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
);

export const ProfessionalDeleteSchaduleAPI = createAsyncThunk(
    "ProfessionalDeleteSchaduleAPI",
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.delete(endpoints.deleteSchadule(id));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
);

const initialState = {
    loading: false,
    timeLoading: false,
    allTimings: [],
}

const ProfessionalSheduleSlice = createSlice({
    initialState,
    name: "ProfessionalSheduleSlice",
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(ProfessionalAddTimingsAPI.pending, (state, aciton) => {
            state.loading = true
        })

        builder.addCase(ProfessionalAddTimingsAPI.fulfilled, (state, aciton) => {
            state.loading = false;
        })

        builder.addCase(ProfessionalAddTimingsAPI.rejected, (state, aciton) => {
            state.loading = false
        })

        //SHOW TININGS SLOTS

        builder.addCase(ProfessionalShowTimingsAPI.pending, (state, aciton) => {
            state.timeLoading = true
        })

        builder.addCase(ProfessionalShowTimingsAPI.fulfilled, (state, action) => {
            state.timeLoading = false;
            if (action.payload?.data?.data) {
                state.allTimings = action.payload.data.data;
            } else {
                state.allTimings = [];
            }
        });

        builder.addCase(ProfessionalShowTimingsAPI.rejected, (state, aciton) => {
            state.timeLoading = false
        })

        // delete schedule

        builder.addCase(ProfessionalDeleteSchaduleAPI.pending, (state, aciton) => {
            state.timeLoading = true
        })

        builder.addCase(ProfessionalDeleteSchaduleAPI.fulfilled, (state, action) => {
            state.timeLoading = false;
        });

        builder.addCase(ProfessionalDeleteSchaduleAPI.rejected, (state, aciton) => {
            state.timeLoading = false
        })
    }
})

export const { } = ProfessionalSheduleSlice.actions
export default ProfessionalSheduleSlice.reducer